<template>
  <div>
    <LoadingIndicator v-if="!systems" />
    <SystemFilterBar class="p-3" @search="filterSystems" @reset="resetFilter" />
    <div class="grid-container">
      <el-card
        v-for="system in currentDataset"
        :key="system.id"
        class="p-3 mt-3 item-card d-flex flex-column align-items-center justify-content-center align-top position-relative"
        :class="{ 'eco-border': system.get('ecoLine') }"
        @click.native="goToSystem(system.get('modxId'))"
      >
        <div class="d-flex align-items-center">
          <img class="system-thumbnail" :src="GENERAL.IMAGE_PATH + system.get('image')" />
          <div
            class="text-left"
            v-html="system.get('name').replace('GREEN LINE ECO', `<span style='color: #9bc524'>GREEN LINE ECO</span>`)"
          />
          <div v-if="system.get('ecoLine')" class="p-2" style="position: absolute; top: 5px; right: 5px;">
            <img width="30" src="@/assets/images/misc/viacor-greenlabel_80.png" />
          </div>
        </div>
        <div v-if="system.get('attributes')" class="font-weight-light mt-4">
          {{
            system
              .get('attributes')
              .map((el) => el.get('name'))
              .join(', ')
              .substring(0, 150)
          }}
        </div>
      </el-card>
    </div>
    <NoResults v-if="currentDataset.length === 0 && showSearchResults" :text="$t('general.no_result')" />
  </div>
</template>

<script>
import GENERAL from '@/config/general';

import LoadingIndicator from '../../components/loading/LoadingIndicator';
import NoResults from '../../components/NoResults';
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import SystemFilterBar from './components/SystemFilterBar';
export default {
  name: 'SystemsView',
  components: { SystemFilterBar, NoResults, LoadingIndicator },
  props: {},
  mounted() {
    this.loadSystems();
  },
  destroyed() {},
  data() {
    return {
      GENERAL,
      showSearchResults: false,
      filteredData: [],
    };
  },
  computed: {
    ...mapGetters(StoreModules.SYSTEMS, ['systems']),
    currentDataset() {
      if (this.showSearchResults) return this.filteredData;
      else return this.systems;
    },
  },
  methods: {
    ...mapActions(StoreModules.SYSTEMS, ['loadSystems']),
    filterSystems(filter) {
      let query = { search: JSON.stringify(filter) };

      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ name: this.$route.routeName, query });
      }

      if (!this.systems) return;

      let pp = this.systems;
      if (filter.term) {
        pp = this.systems.filter((el) => {
          if (filter.term) {
            return el
              .get('name')
              .replace(/-/, ' ')
              .toLowerCase()
              .includes(filter.term.replace(/-/, ' ').toLowerCase());
          }
          return false;
        });
      }

      //FILTER ATTRIBUTES
      if (filter.attributes && filter.attributes.items.length > 0)
        pp = pp.filter((el) => {
          let a = filter.attributes.items;

          let r = 0;

          if (!el.get('attributes')) return false;

          for (let i = 0; i < a.length; i++) {
            if (
              el
                .get('attributes')
                .map((m) => m.id)
                .includes(a[i])
            )
              r++;
          }
          if (filter.attributes.type === 'or') {
            return r > 0;
          } else {
            return r === a.length;
          }
        });

      //FILTER GROUPS
      if (filter.groups && filter.groups.items.length > 0)
        pp = pp.filter((el) => {
          let a = filter.groups.items;

          let r = 0;

          if (!el.get('groups')) return false;

          for (let i = 0; i < a.length; i++) {
            if (
              el
                .get('groups')
                .map((m) => m.id)
                .includes(a[i])
            )
              r++;
          }
          if (filter.groups.type === 'or') {
            return r > 0;
          } else {
            return r === a.length;
          }
        });

      this.filteredData = pp;
      this.showSearchResults = true;
    },
    resetFilter() {
      this.filteredData = [];
      this.showSearchResults = false;
    },
    goToSystem(id) {
      this.$router.push({ name: 'SystemViewRoute', params: { id: parseInt(id) } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';

.system-thumbnail {
  min-height: 50px;
  max-height: 50px;
  object-fit: contain;
  margin-right: 1rem;
  min-width: 75px;
}

.eco-border {
  border-top: 5px solid #9bc524;
}
</style>
